import { Col, Row, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { CodarxBtn, CodarxInput, CodarxModal, Title } from "..";
import { noFileImage } from "assets/images";
import styles from "./styles.module.css";
import { useSelector } from "react-redux";
import { CreateNewFile, DeleteFile, UpdateFile } from "services/file";
import uuid from "react-uuid";

const CodarxImageModal = ({
  visible,
  setVisible,
  setImageFileData,
  imageFileData,
  onFinish,
  type,
}) => {
  const colorPalette = useSelector(({ theme }) => theme.palette);

  const [form, setForm] = useState(new FormData());
  const [loading, setLoading] = useState();
  const [image, setImage] = useState(null);
  const [text, setText] = useState("");

  const input_id = uuid();

  const onImageChange = (event) => {
    let image = event.target.files;
    if (image && image[0]) {
      let fd = new FormData();
      fd.append("file", image[0]);
      setForm(fd);
      setImage(URL.createObjectURL(image[0]));
    }
  };
  useEffect(() => {
    if (imageFileData !== null) {
      setText(imageFileData.alt);
      setImage(imageFileData.file);
    }
  }, [imageFileData]);

  useEffect(() => {
    if (!visible) {
      setText("");
      setImage(null);
    }
  }, [visible]);

  return (
    <CodarxModal
      onCancel={() => setVisible(false)}
      onOk={() => {
        if (image !== null) {
          const key_updatable = "key_updatable_create_file";
          message.loading({
            key: key_updatable,
            content: "لطفا چند لحظه صبر کنید",
          });
          setLoading(true);
          form.set("alt", text);
          if (type == "create") {
            CreateNewFile(form)
              .then((res) => {
                message.success({
                  key: key_updatable,
                  content: "فایل با موفقیت ایجاد شد",
                });
                setLoading(false);
                onFinish(res);
                setVisible(false);
              })
              .catch((res) => {
                message.error({
                  key: key_updatable,
                  content: "خطا در ایجاد فایل",
                });
                setLoading(false);
              });
          } else {
            UpdateFile(imageFileData.id, form)
              .then((res) => {
                message.success({
                  key: key_updatable,
                  content: "فایل با موفقیت ویرایش شد",
                });
                setLoading(false);
                onFinish(res);
                setVisible(false);
              })
              .catch((err) => {
                message.error({
                  key: key_updatable,
                  content: "خطا در ویرایش فایل",
                });
                setLoading(false);
              });
          }
        } else {
          setVisible(false);
          onFinish();
        }
      }}
      visible={visible}
      loading={loading}
      okText={"ذخیره"}
      cancelText={"برگشت"}
      width={"90%"}
      style={{ maxWidth: "1080px", top: "40px" }}
    >
      <div
        className={styles.category_modal_container}
        style={{ borderBottom: "1px solid " + colorPalette.text.op_9 }}
      >
        <Row>
          <Col sm={{ span: 24 }} md={{ span: 12 }}>
            <div
              className={styles.category_modal_img_container}
              style={{ border: "1px solid " + colorPalette.text.op_9 }}
            >
              <img
                src={image === null ? noFileImage : image}
                alt=""
                className={styles.category_modal_img}
                width={image === null ? "240px" : "100%"}
                height={image === null ? "240px" : "500px"}
              />
            </div>
          </Col>
          <Col sm={{ span: 24 }} md={{ span: 12 }}>
            <Title text={type == "create" ? "افزودن عکس" : "ویرایش عکس"} />
            <div
              className={styles.category_modal_img_info}
              style={{
                backgroundColor: colorPalette.primary.op_9,
                color: colorPalette.text.main,
              }}
            >
              <div className={styles.category_modal_img_date}>
                تاریخ بارگذاری :
                {imageFileData === null
                  ? " --/--/---- "
                  : " " +
                    new Date(
                      imageFileData.created_date.split(" ")[0]
                    ).toLocaleDateString("fa-IR")}
              </div>
              <div className={styles.category_modal_img_info_text}>
                {imageFileData === null
                  ? " -- "
                  : imageFileData.image_dimensions.width +
                    "*" +
                    imageFileData.image_dimensions.height +
                    "   px "}
                : اندازه عکس
              </div>
              <div className={styles.category_modal_img_info_text}>
                {imageFileData === null
                  ? " -- "
                  : " " + imageFileData.size + " kb "}
                : حجم عکس
              </div>
            </div>

            <div>
              <CodarxInput
                placeholder={"متن جایگزین"}
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                }}
              />
            </div>

            <div className={styles.category_modal_btns}>
              <div className={styles.category_modal_btn}>
                <CodarxBtn
                  width="160"
                  height="40"
                  onClick={() => {
                    document.getElementById(input_id).click();
                  }}
                >
                  انتخاب عکس
                  <input
                    onChange={onImageChange}
                    type="file"
                    accept="image/*"
                    id={input_id}
                    className={styles.category_modal_fileinput}
                  />
                </CodarxBtn>
              </div>
              <CodarxBtn
                width="160"
                height="40"
                danger
                ghost={true}
                disabled={image === null ? true : false}
                onClick={() => {
                  if (imageFileData?.id) {
                    const key_updatable = "key_updatable_create_file";
                    setLoading(true);
                    DeleteFile(imageFileData.id)
                      .then((res) => {
                        message.success({
                          key: key_updatable,
                          content: "فایل با موفقیت حذف شد",
                        });
                        setLoading(false);
                        onFinish();
                        setVisible(false);
                      })
                      .catch((err) => {
                        message.error({
                          key: key_updatable,
                          content: "خطا در ویرایش فایل",
                        });
                        setLoading(false);
                      });
                  } else {
                    setImage(null);
                    setForm(new FormData());
                  }
                }}
              >
                حذف عکس
              </CodarxBtn>
            </div>
          </Col>
        </Row>
      </div>
    </CodarxModal>
  );
};
export default CodarxImageModal;

CodarxImageModal.defaultProps = {
  imageFileData: null,
};
